module.exports = __webpack_public_path__ + "img/bg.17545f0e.png";